module.exports = __webpack_public_path__ + "static/media/app-horarios.483195be.png";